module.exports = __webpack_public_path__ + "img/button-delete.f2a60115.svg";